<div class="flex align-items-end mr-2">
  <p-skeleton
    *ngIf="showSkeleton"
    shape="rectangle"
    [ngStyle]="{
      height: '35px',
      width: '100%',
      maxWidth: '70px',
      borderRadius: '6px'
    }"
    height="35px"
  ></p-skeleton>
  <div
    *ngIf="!showSkeleton"
    [ngStyle]="{
      'background-color': colorCode,
      height: '35px',
      width: '100%',
      maxWidth: '70px',
      border: '2px solid #ccc',
      borderRadius: '6px'
    }"
  ></div>
</div>
